import StudentDetails from './StudentDetails';

export default StudentDetails;
